"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Column = exports.FieldWrapper = exports.Spacer = exports.Form = void 0;

var styled_components_1 = __importStar(require("styled-components"));

exports.Form = styled_components_1.default.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /** the default colour of text in the form */\n  color: black;\n"], ["\n  /** the default colour of text in the form */\n  color: black;\n"])));
exports.Spacer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", "rem;\n"], ["\n  padding: ", "rem;\n"])), function (_a) {
  var hide = _a.hide;
  return hide ? 0 : 1;
});
exports.FieldWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 0;\n\n  ", "\n"], ["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 0;\n\n  ", "\n"])), function (_a) {
  var collapsedBreakpoint = _a.collapsedBreakpoint;
  return collapsedBreakpoint && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      @media (min-width: ", ") {\n        grid-template-columns: 1fr 1fr;\n        grid-gap: 1rem;\n      }\n    "], ["\n      @media (min-width: ", ") {\n        grid-template-columns: 1fr 1fr;\n        grid-gap: 1rem;\n      }\n    "])), collapsedBreakpoint);
});
exports.Column = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;